import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "input" }
const _hoisted_2 = {
  class: "password required control-label",
  for: "registration_form_password"
}
const _hoisted_3 = {
  key: 0,
  class: "error"
}
const _hoisted_4 = { class: "password-strength" }
const _hoisted_5 = { class: "input" }
const _hoisted_6 = {
  class: "password required control-label",
  for: "registration_form_password_confirmation"
}
const _hoisted_7 = {
  key: 0,
  class: "error"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PasswordStrength = _resolveComponent("PasswordStrength")

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(`${
        $props.passwordError && 'field_with_errors'
      } input password required registration_form_password`)
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("label", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("abbr", { title: "required" }, "*", -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('simple_form.labels.registration_form.password')), 1)
        ]),
        _createElementVNode("input", {
          class: "password required password-strength-input",
          id: "registration_form_password",
          autocomplete: "off",
          required: "required",
          "aria-required": "true",
          type: "password",
          name: "registration_form[password]",
          onInput: _cache[0] || (_cache[0] = (e) => $options.onPasswordChange(e.target.value))
        }, null, 32),
        ($props.passwordError)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($props.passwordError), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_PasswordStrength, {
            index: "0",
            strength: _ctx.passwordStrength
          }, null, 8, ["strength"]),
          _createVNode(_component_PasswordStrength, {
            index: "1",
            strength: _ctx.passwordStrength
          }, null, 8, ["strength"]),
          _createVNode(_component_PasswordStrength, {
            index: "2",
            strength: _ctx.passwordStrength
          }, null, 8, ["strength"]),
          _createVNode(_component_PasswordStrength, {
            index: "3",
            strength: _ctx.passwordStrength
          }, null, 8, ["strength"])
        ])
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(`${
        $props.passwordConfirmationError && 'field_with_errors'
      } input password required registration_form_password_confirmation`)
    }, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("label", _hoisted_6, [
          _cache[2] || (_cache[2] = _createElementVNode("abbr", { title: "required" }, "*", -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('simple_form.labels.registration_form.password_confirmation')), 1)
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("input", {
          id: "registration_form_password_confirmation",
          class: "password required",
          autocomplete: "off",
          required: "required",
          "aria-required": "true",
          type: "password",
          name: "registration_form[password_confirmation]"
        }, null, -1)),
        ($props.passwordConfirmationError)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString($props.passwordConfirmationError), 1))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ]))
}